(function () {

      /* ── CONFIG — edit here only ─────────────────────────────────────────── */

      /* Product handle → keyword mapping for cart detection */
      var PRODUCTS = {
        shampoo:  { keywords: ['shampoo'],    type: 'Shampoo',    label: 'Kids Shampoo',   icon: '🧴', urlAttr: 'data-url-shampoo' },
        oil:      { keywords: ['hair oil', 'scalp'], type: 'Hair Oil', label: 'Kids Hair Oil', icon: '🛢️', urlAttr: 'data-url-oil' },
        bodywash: { keywords: ['body wash'],   type: 'Body Wash', label: 'Body Wash',      icon: '🪷', urlAttr: 'data-url-bodywash' },
        lotion:   { keywords: ['lotion'],      type: 'Body Lotion', label: 'Body Lotion',  icon: '💧', urlAttr: 'data-url-lotion' }
      };

      /* Combo products and which routine items they count as */
      var COMBOS = [
        { keywords: ['complete care'],  counts: ['shampoo', 'lotion'] },
        { keywords: ['hair care'],      counts: ['shampoo', 'oil'] },
        { keywords: ['body care'],      counts: ['bodywash', 'lotion'] }
      ];

      /* Bundle deals — Option C */
      var BUNDLES = [
        { key: 'shampoo',  label: 'Shampoo',    targetQty: 2, bundlePrice: 1299, savings: 299, icon: '🧴' },
        { key: 'bodywash', label: 'Body Wash',   targetQty: 2, bundlePrice: 1099, savings: 391, icon: '🪷' },
        { key: 'lotion',   label: 'Body Lotion', targetQty: 2, bundlePrice: 1099, savings: 391, icon: '💧' },
        { key: 'oil',      label: 'Hair Oil',    targetQty: 2, bundlePrice: 799,  savings: 159, icon: '🛢️' }
      ];

      /* ─────────────────────────────────────────────────────────────────────── */

      /* Build locale-aware Shopify Ajax API URLs. */
         function getShopifyRoute(path) {
          var root = window.Shopify &&
            window.Shopify.routes &&
            window.Shopify.routes.root
              ? window.Shopify.routes.root
              : '/';

          return root + path.replace(/^\/+/, '');
        }

        /* Reject unsuccessful Shopify responses before reading their JSON. */
        function parseJsonResponse(response) {
          if (!response.ok) {
            throw new Error(
              'Shopify Ajax request failed with status ' + response.status
            );
          }

          return response.json();
        }

      /* ── Get product URLs from DOM data attributes ── */
      function getUrls() {
        var el = document.getElementById('syoat-cmb');
        if (!el) return {};
        var urls = {};
        Object.keys(PRODUCTS).forEach(function (key) {
          urls[key] = el.getAttribute(PRODUCTS[key].urlAttr) || '#';
        });
        return urls;
      }

      /* ── Detect which routine products are in cart ── */
      function detectCart(cartItems) {
        var present = { shampoo: 0, oil: 0, bodywash: 0, lotion: 0 };

        cartItems.forEach(function (item) {
          var title = (item.title || '').toLowerCase();
          var ptype = (item.product_type || '').toLowerCase();

          /* Check if it is a combo — count its constituent products */
          var isCombo = false;
          COMBOS.forEach(function (combo) {
            if (combo.keywords.some(function (kw) { return title.indexOf(kw) !== -1; })) {
              isCombo = true;
              combo.counts.forEach(function (key) { present[key] += item.quantity; });
            }
          });
          if (isCombo) return;

          /* Match individual products */
          Object.keys(PRODUCTS).forEach(function (key) {
            var p = PRODUCTS[key];
            var kwMatch = p.keywords.some(function (kw) { return title.indexOf(kw) !== -1; });
            var typeMatch = ptype === p.type.toLowerCase();
            if (kwMatch || typeMatch) { present[key] += item.quantity; }
          });
        });

        return present;
      }

      /* ── Option A: Routine push logic ── */
      function getRoutineState(present, urls) {
        var has = {
          shampoo:  present.shampoo  > 0,
          oil:      present.oil      > 0,
          bodywash: present.bodywash > 0,
          lotion:   present.lotion   > 0
        };

        /* Priority order of routine pushes */
        if (!has.shampoo && !has.oil && !has.bodywash && !has.lotion) {
          return { msg: 'Build your child\'s complete care routine 🌿', type: 'empty', cta: null, url: null };
        }
        if (has.shampoo && !has.oil) {
          return { msg: '🛢️ Your child\'s hair routine is missing Hair Oil', type: 'missing', cta: 'Add Hair Oil', url: urls.oil };
        }
        if (has.oil && !has.shampoo) {
          return { msg: '🧴 Your child\'s hair routine is missing Shampoo', type: 'missing', cta: 'Add Shampoo', url: urls.shampoo };
        }
        if (has.shampoo && has.oil && !has.bodywash) {
          return { msg: '🪷 Your child\'s bath routine is missing Body Wash', type: 'missing', cta: 'Add Body Wash', url: urls.bodywash };
        }
        if (has.bodywash && !has.lotion) {
          return { msg: '💧 Skin needs moisture — Body Lotion is missing', type: 'missing', cta: 'Add Body Lotion', url: urls.lotion };
        }
        if (has.lotion && !has.bodywash) {
          return { msg: '🪷 Your child\'s bath routine is missing Body Wash', type: 'missing', cta: 'Add Body Wash', url: urls.bodywash };
        }
        if (has.bodywash && has.lotion && !has.shampoo) {
          return { msg: '🧴 Complete the full routine — Shampoo is missing', type: 'missing', cta: 'Add Shampoo', url: urls.shampoo };
        }
        /* Full routine */
        return { msg: '🎉 Full routine complete! Your child is all set', type: 'complete', cta: null, url: null };
      }

      /* ── Update DOM ── */
      function updateBar(cartItems, cartDiscountTotal) {
        var msgEl     = document.getElementById('syoat-cmb-msg');
        var ctaEl     = document.getElementById('syoat-cmb-cta');
        var ctaTxtEl  = document.getElementById('syoat-cmb-cta-text');
        var savingsEl = document.getElementById('syoat-cmb-savings');
        var savingsVal= document.getElementById('syoat-cmb-savings-val');

        var items             = cartItems || [];
        var cartDiscountSaved = Math.round((cartDiscountTotal || 0) / 100);
        var present           = detectCart(items);

        if (msgEl) {
          var urls = getUrls();
          var routine = getRoutineState(present, urls);
          msgEl.textContent = routine.msg;
          msgEl.className = 'syoat-cmb__routine-msg is-' + routine.type;

          if (routine.cta && ctaEl && ctaTxtEl) {
            ctaTxtEl.textContent = routine.cta;
            ctaEl.href = routine.url || '#';
            ctaEl.classList.remove('hidden');
          } else if (ctaEl) {
            ctaEl.classList.add('hidden');
          }
        }

        /* Show the same-product bundle nudge directly below the qualifying line. */
        document.querySelectorAll('[data-syoat-bundle-upsell]').forEach(function (offerEl) {
          var title = (offerEl.getAttribute('data-product-title') || '').toLowerCase();
          var productType = (offerEl.getAttribute('data-product-type') || '').toLowerCase();
          var matchingBundle = null;

          BUNDLES.forEach(function (bundleConfig) {
            var productConfig = PRODUCTS[bundleConfig.key];
            if (!productConfig || matchingBundle) return;
            var keywordMatch = productConfig.keywords.some(function (keyword) {
              return title.indexOf(keyword) !== -1;
            });
            var typeMatch = productType === productConfig.type.toLowerCase();
            if ((keywordMatch || typeMatch) && present[bundleConfig.key] === 1) {
              matchingBundle = bundleConfig;
            }
          });

          var offerMessage = offerEl.querySelector('[data-syoat-bundle-upsell-message]');
          if (matchingBundle && offerMessage) {
            // Syoat: Avoid retriggering the cart observer when the message is unchanged.
            var nextMessage = 'Add 1 more - save ₹' + matchingBundle.savings;
            if (offerMessage.textContent !== nextMessage) offerMessage.textContent = nextMessage;
            offerEl.classList.remove('hidden');
          } else {
            offerEl.classList.add('hidden');
          }
        });

        /* Savings badge
           1. compare_at_price savings — per line item, all products
           2. Bundle savings — when 2x same product threshold met
           Combined into one total shown in the savings badge */

        /* 1. compare_at_price savings across all line items
           Uses _compare_at_price fetched from product API (cart API omits it) */
        var compareSaved = items.reduce(function (sum, item) {
          var cap = item._compare_at_price || 0;
          var price = item.price || 0;
          if (cap > price) {
            return sum + ((cap - price) * item.quantity);
          }
          return sum;
        }, 0);
        /* Shopify returns prices in paise — convert to rupees */
        compareSaved = Math.round(compareSaved / 100);

        /* Only count savings Shopify has actually applied. Bundle configuration
           drives the nudge copy above; it must never manufacture a saving that is
           absent from Shopify's cart totals. */
        var totalSaved = compareSaved + cartDiscountSaved;

        if (savingsEl && savingsVal) {
          if (totalSaved > 0) {
            var prevSaved = parseInt(savingsEl.dataset.prevSaved || '0', 10);
            savingsVal.textContent = '₹' + totalSaved;
            savingsEl.classList.remove('hidden');
            /* Fire confetti when savings appear or amount changes */
            if (totalSaved !== prevSaved) {
              savingsEl.dataset.prevSaved = totalSaved;
              syoatConfetti(savingsEl);
            }
          } else {
            savingsEl.classList.add('hidden');
            savingsEl.dataset.prevSaved = '0';
          }
        }
      }

      function syoatConfetti(anchorEl) {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        var COLORS = ['#5b4636','#D7CABA','#f3eee7','#fcd34d','#86efac','#fca5a5','#93c5fd'];
        var PIECES = 32;
        var DURATION = 2000;

        /* Position relative to anchor element */
        var rect = anchorEl.getBoundingClientRect();
        var originX = rect.left + rect.width / 2;
        var originY = rect.top + rect.height / 2;

        var canvas = document.createElement('canvas');
        canvas.style.cssText = [
          'position:fixed',
          'top:0',
          'left:0',
          'width:100%',
          'height:100%',
          'pointer-events:none',
          'z-index:99999'
        ].join(';');
        canvas.width  = window.innerWidth;
        canvas.height = window.innerHeight;
        document.body.appendChild(canvas);
        var ctx = canvas.getContext('2d');

        /* Create particles */
        var particles = [];
        for (var i = 0; i < PIECES; i++) {
          var angle  = (Math.PI * 2 / PIECES) * i + (Math.random() - 0.5) * 0.8;
          var speed  = 3 + Math.random() * 5;
          particles.push({
            x:    originX,
            y:    originY,
            vx:   Math.cos(angle) * speed,
            vy:   Math.sin(angle) * speed - 4, /* bias upward */
            size: 5 + Math.random() * 6,
            color: COLORS[Math.floor(Math.random() * COLORS.length)],
            rotation: Math.random() * Math.PI * 2,
            rotSpeed: (Math.random() - 0.5) * 0.3,
            shape: Math.random() > 0.5 ? 'rect' : 'circle',
            opacity: 1
          });
        }

        var start = null;
        function draw(ts) {
          if (!start) start = ts;
          var elapsed = ts - start;
          var progress = elapsed / DURATION;

          ctx.clearRect(0, 0, canvas.width, canvas.height);

          particles.forEach(function (p) {
            p.x  += p.vx;
            p.y  += p.vy;
            p.vy += 0.18; /* gravity */
            p.rotation += p.rotSpeed;
            p.opacity = Math.max(0, 1 - progress * 1.2);

            ctx.save();
            ctx.globalAlpha = p.opacity;
            ctx.translate(p.x, p.y);
            ctx.rotate(p.rotation);
            ctx.fillStyle = p.color;

            if (p.shape === 'rect') {
              ctx.fillRect(-p.size / 2, -p.size / 4, p.size, p.size / 2);
            } else {
              ctx.beginPath();
              ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2);
              ctx.fill();
            }
            ctx.restore();
          });

          if (elapsed < DURATION) {
            requestAnimationFrame(draw);
          } else {
            canvas.remove();
          }
        }

        requestAnimationFrame(draw);
      }

      /* ── compare_at_price cache — keyed by variant_id ── */
      var _capCache = {};
      var _giftSyncInFlight = false;
      var _giftSyncBlockedUntil = 0;
      var _giftRemovalRetryCount = 0;
      // Syoat: After a gift discount fails, respect removal for this tab's cart.
      var _giftAutoAddPaused = false;
      try { _giftAutoAddPaused = sessionStorage.getItem('syoat-gift-auto-add-paused') === 'true'; } catch (error) {}
      function pauseGiftAutoAdd(paused) {
        _giftAutoAddPaused = paused;
        try {
          if (paused) sessionStorage.setItem('syoat-gift-auto-add-paused', 'true');
          else sessionStorage.removeItem('syoat-gift-auto-add-paused');
        } catch (error) {}
      }

      /* Fetch compare_at_price for a single variant from product API.
         Shopify cart API does not return compare_at_price on line items,
         so we fetch it from /products/<handle>.js and cache the result. */
      function fetchCap(handle, variantId) {
        /* Coerce to string — JS object keys are always strings,
           variantId from cart.js is a number which causes cache misses */
        var key = String(variantId);
        if (_capCache[key] !== undefined) {
          return Promise.resolve(_capCache[key]);
        }
        return fetch(getShopifyRoute('products/' + handle + '.js'))
          .then(parseJsonResponse)
          .then(function (p) {
            (p.variants || []).forEach(function (v) {
              _capCache[String(v.id)] = v.compare_at_price || 0;
            });
            return _capCache[key] || 0;
          })
          .catch(function () { return 0; });
      }

      function isThresholdGift(item) {
        return item.properties && item.properties._syoat_threshold_gift === 'true';
      }

      /* Syoat: A marked gift with a charge must never remain checkoutable. */
      function removeChargedThresholdGifts(cart) {
        var chargedGiftLine = -1;
        (cart.items || []).some(function (item, index) {
          if (!isThresholdGift(item) || item.final_line_price <= 0) return false;
          chargedGiftLine = index + 1;
          return true;
        });
        if (chargedGiftLine < 1) {
          _giftRemovalRetryCount = 0;
          return false;
        }

        pauseGiftAutoAdd(true);
        _giftRemovalRetryCount += 1;
        return requestGiftMutation(getShopifyRoute('cart/change.js'), {
          line: chargedGiftLine,
          quantity: 0
        });
      }

      function getGiftConfig() {
        var el = document.getElementById('syoat-cmb') || document.querySelector('[data-syoat-gift-progress]');
        if (!el) return null;

        return {
          variantId: parseInt(el.getAttribute('data-gift-variant-id') || '0', 10),
          threshold: parseInt(el.getAttribute('data-gift-threshold') || '0', 10),
          available: el.getAttribute('data-gift-available') === 'true'
        };
      }

      function setGiftProgressError() {
        var el = document.querySelector('[data-syoat-gift-progress]');
        if (!el) return;
        el.classList.remove('is-unlocked', 'is-adding');
        el.classList.add('is-error');
        el.textContent = 'Free gift could not be updated. Please refresh your cart.';
      }

      function getBundledSectionIds() {
        var ids = [];
        var quickCart = document.querySelector('[data-section-type="quick-cart"][data-section-id]');
        var header = document.querySelector('[data-section-type="header"][data-section-id]');
        if (quickCart) ids.push(quickCart.getAttribute('data-section-id'));
        if (header) ids.push(header.getAttribute('data-section-id'));
        return ids.filter(Boolean);
      }

      function replaceSectionPart(currentRoot, freshRoot, selector) {
        var current = currentRoot.querySelector(selector);
        var fresh = freshRoot.querySelector(selector);
        if (current && fresh) current.innerHTML = fresh.innerHTML;
      }

      function refreshBundledSections(sections) {
        if (!sections) return;
        var parser = new DOMParser();

        Object.keys(sections).forEach(function (sectionId) {
          var html = sections[sectionId];
          if (!html) return;
          var freshDoc = parser.parseFromString(html, 'text/html');
          var freshQuickCart = freshDoc.querySelector('[data-section-type="quick-cart"]');
          var currentQuickCart = document.querySelector('[data-section-type="quick-cart"]');

          if (freshQuickCart && currentQuickCart) {
            replaceSectionPart(currentQuickCart, freshQuickCart, '.quick-cart__heading');
            replaceSectionPart(currentQuickCart, freshQuickCart, '.quick-cart__items');
            replaceSectionPart(currentQuickCart, freshQuickCart, '.quick-cart__footer');
            replaceSectionPart(currentQuickCart, freshQuickCart, '#syoat-cmb');

            if (freshQuickCart.hasAttribute('data-syoat-charged-gift-cart')) {
              currentQuickCart.setAttribute('data-syoat-charged-gift-cart', '');
            } else {
              currentQuickCart.removeAttribute('data-syoat-charged-gift-cart');
            }
          }

          var freshHeader = freshDoc.querySelector('[data-section-type="header"]');
          var currentHeader = document.querySelector('[data-section-type="header"]');
          if (freshHeader && currentHeader) {
            var freshCarts = freshHeader.querySelectorAll('[data-header-cart]');
            var currentCarts = currentHeader.querySelectorAll('[data-header-cart]');
            currentCarts.forEach(function (currentCart, index) {
              var freshCart = freshCarts[index];
              if (!freshCart) return;
              currentCart.innerHTML = freshCart.innerHTML;
              currentCart.setAttribute('data-cart-count', freshCart.getAttribute('data-cart-count') || '0');
            });
          }
        });
      }

      function refreshCartAfterServerCleanup() {
        var sectionIds = getBundledSectionIds();
        if (!sectionIds.length) {
          window.location.reload();
          return;
        }

        var separator = window.location.pathname.indexOf('?') === -1 ? '?' : '&';
        var url = window.location.pathname + separator + 'sections=' + encodeURIComponent(sectionIds.join(','));
        fetch(url, { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(parseJsonResponse)
          .then(function (sections) {
            refreshBundledSections(sections);
            if (document.querySelector('[data-syoat-unpriced-gift-remove]')) window.location.reload();
          })
          .catch(function () { window.location.reload(); });
      }

      function enrichAndUpdate(cart) {
        var items = cart.items || [];
        if (!items.length) { updateBar([], 0); return; }

        var fetches = items.map(function (item) {
          return fetchCap(item.handle, item.variant_id).then(function (cap) {
            item._compare_at_price = cap || 0;
          });
        });

        Promise.all(fetches).then(function () {
          updateBar(items, cart.total_discount || 0);
        });
      }

      function completeGiftMutation(response) {
        refreshBundledSections(response.sections);
        return fetch(getShopifyRoute('cart.js'))
          .then(parseJsonResponse)
          .then(function (cart) {
            _giftSyncInFlight = false;
            if (window.theme) window.theme.cartData = cart;
            if (document.querySelector('[data-syoat-unpriced-gift-remove]') &&
                !(cart.items || []).some(isThresholdGift)) {
              _giftRemovalRetryCount = 0;
              refreshCartAfterServerCleanup();
              return;
            }
            if (document.querySelector('[data-section-type="cart"][data-syoat-charged-gift-cart]')) {
              window.location.reload();
              return;
            }
            enrichAndUpdate(cart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('quick-cart:updated', { detail: { cart: cart } }));
          });
      }

      function recoverGiftMutation() {
        return fetch(getShopifyRoute('cart.js'))
          .then(parseJsonResponse)
          .then(function (cart) {
            var giftIsPresent = (cart.items || []).some(isThresholdGift);
            _giftSyncInFlight = false;

            if (!giftIsPresent) {
              _giftRemovalRetryCount = 0;
              if (window.theme) window.theme.cartData = cart;
              refreshCartAfterServerCleanup();
              return;
            }

            if (window.theme) window.theme.cartData = cart;
            enrichAndUpdate(cart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('quick-cart:updated', { detail: { cart: cart } }));
            if (_giftRemovalRetryCount < 3) {
              _giftSyncBlockedUntil = Date.now() + 600;
              setTimeout(refreshBar, 700);
            } else {
              _giftSyncBlockedUntil = Date.now() + 5000;
              setGiftProgressError();
            }
          })
          .catch(function () {
            _giftSyncInFlight = false;
            _giftSyncBlockedUntil = Date.now() + 5000;
            setGiftProgressError();
          });
      }

      function requestGiftMutation(requestUrl, requestBody) {
        var sectionIds = getBundledSectionIds();
        if (sectionIds.length) {
          requestBody.sections = sectionIds;
          requestBody.sections_url = window.location.pathname;
        }

        _giftSyncInFlight = true;
        fetch(requestUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(requestBody)
        })
          .then(parseJsonResponse)
          .then(completeGiftMutation)
          .catch(recoverGiftMutation);

        return true;
      }

      function addThresholdGiftFromRenderedState() {
        var progressEl = document.querySelector('[data-syoat-gift-progress][data-gift-state="adding"]');
        var config = getGiftConfig();
        if (_giftAutoAddPaused || !progressEl || !config || !config.available || !config.variantId) return false;
        if (_giftSyncInFlight || Date.now() < _giftSyncBlockedUntil) return _giftSyncInFlight;

        return requestGiftMutation(getShopifyRoute('cart/add.js'), {
          items: [{
            id: config.variantId,
            quantity: 1,
            properties: { _syoat_threshold_gift: 'true' }
          }]
        });
      }

      function syncThresholdGift(cart) {
        var config = getGiftConfig();
        if (!config || !config.available || !config.variantId || !config.threshold) return false;
        if (_giftSyncInFlight || Date.now() < _giftSyncBlockedUntil) return _giftSyncInFlight;

        var markedGifts = (cart.items || []).filter(isThresholdGift);
        var eligibleTotal = (cart.items || []).reduce(function (sum, item) {
          return sum + (isThresholdGift(item) ? 0 : (item.final_line_price || 0));
        }, 0);
        var qualifies = eligibleTotal >= config.threshold;
        if (!qualifies) pauseGiftAutoAdd(false);
        else if (markedGifts.some(function (item) { return item.final_line_price > 0; })) pauseGiftAutoAdd(true);
        var updates = {};
        var requestUrl;
        var requestBody;

        if (qualifies && markedGifts.length === 0) {
          if (_giftAutoAddPaused) {
            var progress = document.querySelector('[data-syoat-gift-progress]');
            var pausedMessage = 'Gift offer is paused because the discount did not apply.';
            if (progress) {
              progress.classList.remove('is-unlocked', 'is-adding');
              progress.classList.add('is-error');
              if (progress.textContent !== pausedMessage) progress.textContent = pausedMessage;
            }
            return false;
          }
          requestUrl = getShopifyRoute('cart/add.js');
          requestBody = {
            items: [{
              id: config.variantId,
              quantity: 1,
              properties: { _syoat_threshold_gift: 'true' }
            }]
          };
        } else if (!qualifies && markedGifts.length > 0) {
          markedGifts.forEach(function (item) { updates[item.key] = 0; });
        } else if (qualifies && (markedGifts.length > 1 || markedGifts[0].quantity !== 1)) {
          markedGifts.forEach(function (item, index) { updates[item.key] = index === 0 ? 1 : 0; });
        } else {
          return false;
        }

        if (!requestUrl) {
          requestUrl = getShopifyRoute('cart/update.js');
          requestBody = { updates: updates };
        }

        return requestGiftMutation(requestUrl, requestBody);
      }

      function addBundleItem(button) {
        var variantId = parseInt(button.getAttribute('data-variant-id') || '0', 10);
        if (!variantId || button.disabled) return;

        var requestBody = { items: [{ id: variantId, quantity: 1 }] };
        var sectionIds = getBundledSectionIds();
        if (sectionIds.length) {
          requestBody.sections = sectionIds;
          requestBody.sections_url = window.location.pathname;
        }

        button.disabled = true;
        button.textContent = 'Adding...';

        fetch(getShopifyRoute('cart/add.js'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(requestBody)
        })
          .then(parseJsonResponse)
          .then(function (response) {
            refreshBundledSections(response.sections);
            return fetch(getShopifyRoute('cart.js')).then(parseJsonResponse);
          })
          .then(function (cart) {
            if (window.theme) window.theme.cartData = cart;
            enrichAndUpdate(cart);
            document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            document.dispatchEvent(new CustomEvent('quick-cart:updated', { detail: { cart: cart } }));
          })
          .catch(function () {
            button.disabled = false;
            button.textContent = 'Try again';
          });
      }

      /* ── Fetch live cart then update bar ── */
      function refreshBar() {
        fetch(getShopifyRoute('cart.js'))
          .then(parseJsonResponse)
          .then(function (cart) {
            if (!removeChargedThresholdGifts(cart) && !syncThresholdGift(cart)) enrichAndUpdate(cart);
          })
          .catch(function () { updateBar([], 0); });
      }

      /* Expose globally for external scripts */
      window.syoatRefreshCartBar = refreshBar;

      /* ── Refresh only when the quick cart is used ── */
var _refreshTimer;
var _retryTimer;

function refreshWithRetry(attempts) {
  attempts = attempts || 0;
  clearTimeout(_retryTimer);

  var milestoneEl = document.getElementById('syoat-cmb') || document.querySelector('[data-syoat-gift-progress]');

  if (!milestoneEl) {
    if (attempts < 5) {
      _retryTimer = setTimeout(function () {
        refreshWithRetry(attempts + 1);
      }, 200);
    }
    return;
  }

  refreshBar();
}

function scheduleRefresh() {
  clearTimeout(_refreshTimer);

  _refreshTimer = setTimeout(function () {
    attachObserver();
    refreshWithRetry(0);
  }, 120);
}

var _chargedGiftGuardTimer;

function hasRenderedChargedGift() {
  return Boolean(document.querySelector('[data-syoat-unpriced-gift-remove]'));
}

/* Syoat: AJAX cart updates can replace the gift row before the quick-cart
   footer. Lock checkout from the rendered charged-gift row and remove it. */
function guardRenderedChargedGift() {
  if (!hasRenderedChargedGift()) return false;

  document.querySelectorAll('button[name="checkout"], input[name="checkout"]').forEach(function (button) {
    button.disabled = true;
    button.setAttribute('aria-disabled', 'true');
    button.setAttribute('aria-busy', 'true');

    if (button.tagName === 'INPUT') {
      if (button.value !== 'Updating cart...') button.value = 'Updating cart...';
    } else {
      if (button.textContent !== 'Updating cart...') button.textContent = 'Updating cart...';
    }
  });

  clearTimeout(_chargedGiftGuardTimer);
  _chargedGiftGuardTimer = setTimeout(function () {
    if (hasRenderedChargedGift() && typeof window.syoatRefreshCartBar === 'function') {
      window.syoatRefreshCartBar();
    }
  }, 300);

  return true;
}

/* Cornerstone cart and quick-cart events */
document.addEventListener('cart:updated', scheduleRefresh);
document.addEventListener('cart:item-added', scheduleRefresh);
document.addEventListener('cart:refresh', scheduleRefresh);
document.addEventListener('cart:change', scheduleRefresh);
document.addEventListener('quick-cart:open', function () {
  if (!addThresholdGiftFromRenderedState()) scheduleRefresh();
});
document.addEventListener('quick-cart:updated', scheduleRefresh);

/* The Cornerstone header cart link opens the drawer without always exposing
   quick-cart:open as a document event. Handle its click directly. */
document.addEventListener('click', function (event) {
  var target = event.target;

  if (target && target.closest) {
    if (target.closest('[data-syoat-unpriced-gift-remove]')) pauseGiftAutoAdd(true);
    var bundleButton = target.closest('[data-syoat-bundle-add]');
    if (bundleButton) {
      event.preventDefault();
      addBundleItem(bundleButton);
      return;
    }
  }

  if (target && target.closest && target.closest('[data-header-cart]')) {
    /* Syoat: Preserve the AJAX drawer when a refreshed header loses its
       Cornerstone click delegate. The normal theme handler wins when present. */
    if (!event.defaultPrevented && document.querySelector('.quick-cart')) {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('quick-cart:open'));
    }

    scheduleRefresh();
  }
});

/* Prevent a stale AJAX footer from submitting while a charged gift is shown. */
document.addEventListener('click', function (event) {
  var target = event.target;
  if (!target || !target.closest || !target.closest('[name="checkout"]')) return;
  if (!guardRenderedChargedGift()) return;

  event.preventDefault();
  event.stopImmediatePropagation();
}, true);

/* Detect complete quick-cart container replacements as a fallback. */
function attachObserver() {
  var containerEl = document.querySelector('.quick-cart__container');

  /* Detect complete quick-cart replacements. */
  if (containerEl && !containerEl._syoatObserved) {
    containerEl._syoatObserved = true;

    new MutationObserver(function () {
      scheduleRefresh();
    }).observe(containerEl, {
      childList: true,
      subtree: false
    });
  }

  /* Detect quantity, price and discount changes inside existing cart items. */
  var itemsEl = document.querySelector('.quick-cart__items');

  if (itemsEl && !itemsEl._syoatItemsObserved) {
    itemsEl._syoatItemsObserved = true;

    new MutationObserver(function () {
      scheduleRefresh();
    }).observe(itemsEl, {
      childList: true,
      subtree: true
    });
  }
}

/* Keep this observer outside the replaceable quick-cart markup so it survives
   complete drawer rerenders performed by the base theme. */
if (!document.documentElement._syoatChargedGiftObserved) {
  document.documentElement._syoatChargedGiftObserved = true;
  new MutationObserver(function () {
    guardRenderedChargedGift();
  }).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
}

/* Attach the fallback observer without requesting cart data. */
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function () {
    attachObserver();
    if (!guardRenderedChargedGift() && document.querySelector('[data-syoat-charged-gift-cart]')) refreshBar();
  });
} else {
  attachObserver();
  if (!guardRenderedChargedGift() && document.querySelector('[data-syoat-charged-gift-cart]')) refreshBar();
}

    })();
